import { PropsWithChildren } from "react";

export function Section({ children }: PropsWithChildren<{}>) {
  return <div className="section">{children}</div>;
}
